import { render } from "./LoadTranslation.vue?vue&type=template&id=105bf116"
import script from "./LoadTranslation.vue?vue&type=script&lang=js"
export * from "./LoadTranslation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__